module.exports = __webpack_public_path__ + "static/img/a6.165b7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a6.png
// module id = 4UYL
// module chunks = 0